<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-6 col-lg-4 g-0">
      <div class="card my-3">
        <app-user-title title="registreren" [icon]="faUserCircle">
        </app-user-title>

        @if(!processing()) {
          <div class="card-body card-body-auth">
            @if(alert) {            
              <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
            }
            @if(registered) {
              <div class="card card-body mx-auto bg-faded mt-3">
                <ngb-alert type="success">Je bent geregistreerd. Valideer nog je emailadres door op de link in
                  de email, die je van ons hebt ontvangen, te klikken.
                </ngb-alert>
                <ngb-alert type="warning">Let op: het kan zijn dat de email in de spam-folder is gekomen.
                </ngb-alert>
              </div>
            } @else {
              @if(isLoggedIn()) {
              <div class="card card-body mx-auto bg-faded mt-3">
                <ngb-alert type="warning">Je bent al ingelogd.</ngb-alert>
              </div>
              } @else {
                <form name="form" (ngSubmit)="register()" [formGroup]="form" novalidate>
                  <!-- emailadres -->
                  <div class="row">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">
                        <fa-icon [icon]=faEnvelope></fa-icon>
                      </span>
                      <input class="form-control"
                        ngClass="{ 'is-invalid': form.controls.emailaddress.invalid, 'is-valid': form.controls.emailaddress.valid }"
                        type="text" formControlName="emailaddress" placeholder="emailadres">
                    </div>
                  </div>
                  <!-- gebruikersnaam -->
                  <div class="row mt-4">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">
                        <fa-icon [icon]=faUserCircle></fa-icon>
                      </span>
                      <input class="form-control"
                        ngClass="{ 'is-invalid': form.controls.name.invalid, 'is-valid': form.controls.name.valid }" type="text"
                        formControlName="name" placeholder="gebruikersnaam">
                    </div>
                  </div>
                  <!-- wachtwoord -->
                  <div class="row mt-4">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">
                        <fa-icon [icon]=faKey></fa-icon>
                      </span>
                      <input class="form-control"
                        ngClass="{ 'is-invalid': form.controls.password.invalid, 'is-valid': form.controls.password.valid }"
                        type="password" formControlName="password" placeholder="wachtwoord">
                    </div>
                  </div>
                  <!-- herhaal wachtwoord -->
                  <div class="row mt-4">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">
                        <fa-icon [icon]=faKey></fa-icon>
                      </span>
                      <input class="form-control"
                        ngClass="{ 'is-invalid': form.controls.passwordRepeat.invalid, 'is-valid': form.controls.passwordRepeat.valid }"
                        type="password" formControlName="passwordRepeat" placeholder="herhaal wachtwoord">
                    </div>
                  </div>
                  <div class="row mt-4 g-0">
                    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
                      registreren
                    </button>
                  </div>
                </form>
              }
            }   
          </div>
        } @else {
          <h2 class="text-center">
            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          </h2>
        }
      </div>
    </div>
  </div>
</div>